import {MatGoogleMapsAutocompleteModule} from "@angular-material-extensions/google-maps-autocomplete";
import {registerLocaleData} from "@angular/common";

import {provideHttpClient, withInterceptors, withInterceptorsFromDi,} from "@angular/common/http";
import localeZa from '@angular/common/locales/en-ZA';
import {CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ConsoleUserService} from "@core-services/console-user.service";
import {networkInterceptorFn} from "@core-services/network-interceptor.service";
import {tokenInterceptorFn} from "@core/interceptors/token-interceptor.service";
import {unauthenticatedAccessInterceptorFn} from "@core/interceptors/unauthenticated-access-interceptor.service";
import {environment} from "@env/environment";
import {FeatureAccountsModule} from "@modules/landlord-portal/features/feature-accounts.module";
import {FeatureAtokuModule} from "@modules/landlord-portal/features/feature-atoku.module";
import {FeatureDashboardsModule} from "@modules/landlord-portal/features/feature-dashboards.module";
import {FeatureLeadsModule} from "@modules/landlord-portal/features/feature-leads.module";
import {FeatureLeasingModule} from "@modules/landlord-portal/features/feature-leasing.module";
import {FeaturePortalModule} from "@modules/landlord-portal/features/feature-portal.module";
import {FeatureSettingsModule} from "@modules/landlord-portal/features/feature-settings.module";
import {FeatureSpacesModule} from "@modules/landlord-portal/features/feature-spaces.module";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AppConfigService} from "@ui-kit/framework/config/app-config.service";
import {CurrentContextService} from "@ui-kit/framework/security/service/current-context.service";
import {UserService} from "@ui-kit/framework/security/service/user.service";
import moment from "moment";
import {LandlordPortalAppConfigService} from "src/app/config/landlord-portal-app-config.service";
import {AngularModule} from "src/app/core/modules/angular.module";
import {AppCoreModule} from "src/app/core/modules/app.core.module";
import {ConsoleContextService} from "src/app/security/console-context.service";
import {AppRoutingModule} from './app-routing.module';

import {AppComponent} from './app.component';


registerLocaleData(localeZa, 'en-za');
moment.locale('en-za');

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
  ],
  exports: [],
  imports: [
    NgbModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    AngularModule,
    AppCoreModule,
    MatGoogleMapsAutocompleteModule.forRoot( environment.googleMapsApiKey),
    FeatureAccountsModule,
    FeatureDashboardsModule,
    FeatureLeasingModule,
    FeatureLeadsModule,
    FeatureSettingsModule,
    FeatureSpacesModule,
    FeaturePortalModule,
    FeatureAtokuModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'en-ZA'},
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([tokenInterceptorFn, unauthenticatedAccessInterceptorFn, networkInterceptorFn])
    ),
    {provide: AppConfigService, useClass: LandlordPortalAppConfigService},
    {provide: CurrentContextService, useClass: ConsoleContextService},
    {provide: UserService, useClass: ConsoleUserService},
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
}
